import {
    Box,
    FormControlLabel,
    Checkbox,
    FormControl,
    RadioGroup,
    Radio,
} from '@mui/material';
import { ReactComponent as Coupon } from '../assets/buy.svg';
import { useState } from "react";

function CouponSelect() {
    // const { tcd, hour, classname, tname, classmemo } = params;
    const [value, setValue] = useState('');

    const couponChange = (e) => {
        setValue(e.target.value);
        console.log(value)
    }
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
            <FormControl
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: 0
                }}>
                <RadioGroup
                    sx={{
                        width: '100%',
                    }}
                    // value={value}
                    // onChange={couponChange}
                >
                    <FormControlLabel
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            margin: 0
                        }}
                        value="1"
                        control={
                            <Box
                                sx={{
                                    width: "84%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    border: "2px solid #dddddd",
                                    padding: "5px",
                                    marginBottom: "10px",
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                    <Box
                                        sx={{
                                            width: "80px",
                                            height: "50px",
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}
                                    >
                                        {/* <img src="/img/class_coupon.png" /> */}
                                        <Coupon
                                            fill='#e93399'
                                            style={{
                                                width: '45px'
                                            }}
                                        />
                                    </Box>
                                    <Box
                                        sx={{
                                            marginLeft: '15px'
                                        }}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    fontSize: "13px",
                                                    // fontWeight: 'bold',
                                                    color: "#e93399",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                클래스쿠폰 36회권
                                            </Box>
                                            <Box
                                                sx={{
                                                    fontSize: "13px",
                                                    color: "#e93399",
                                                    marginLeft: "3px",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {/* x{remain_count} */}
                                                x13
                                            </Box>
                                        </Box>

                                        <Box
                                            sx={{
                                                fontSize: "13px",
                                                color: "#e93399",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {/* {enroll_sdate} ~ {enroll_edate} */}
                                            2022.06.20 까지
                                        </Box>
                                    </Box>
                                </Box>
                                <Radio
                                    size='small'
                                />
                            </Box>
                        }
                        label=''
                    />

                    <FormControlLabel
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            margin: 0
                        }}
                        value="2"
                        control={
                            <Box
                                sx={{
                                    width: "84%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    border: "2px solid #dddddd",
                                    padding: "5px",
                                    marginBottom: "10px",
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                    <Box
                                        sx={{
                                            width: "80px",
                                            height: "50px",
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}
                                    >
                                        {/* <img src="/img/class_coupon.png" /> */}
                                        <Coupon
                                            fill='#e93399'
                                            style={{
                                                width: '45px'
                                            }}
                                        />
                                    </Box>
                                    <Box
                                        sx={{
                                            marginLeft: '15px'
                                        }}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    fontSize: "13px",
                                                    // fontWeight: 'bold',
                                                    color: "#e93399",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                클래스쿠폰 12회권
                                            </Box>
                                            <Box
                                                sx={{
                                                    fontSize: "13px",
                                                    color: "#e93399",
                                                    marginLeft: "3px",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {/* x{remain_count} */}
                                                x8
                                            </Box>

                                        </Box>


                                        <Box
                                            sx={{
                                                fontSize: "13px",
                                                color: "#e93399",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {/* {enroll_sdate} ~ {enroll_edate} */}
                                            2022.06.16 까지
                                        </Box>
                                    </Box>
                                </Box>
                                <Radio
                                    size='small'
                                />
                            </Box>
                        }
                        label=''
                    />

                    <FormControlLabel
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            margin: 0
                        }}
                        value="3"
                        control={
                            <Box
                                sx={{
                                    width: "84%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    border: "2px solid #dddddd",
                                    padding: "5px",
                                    marginBottom: "10px",
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                    <Box
                                        sx={{
                                            width: "80px",
                                            height: "50px",
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                            // border: '1px solid black'
                                        }}
                                    >
                                        {/* <img src="/img/class_coupon.png" /> */}
                                        <Coupon
                                            fill='#D4D4D4'
                                            style={{
                                                width: '45px'
                                            }}
                                        />
                                    </Box>
                                    <Box
                                        sx={{
                                            marginLeft: '15px'
                                        }}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    fontSize: "13px",
                                                    // fontWeight: 'bold',
                                                    color: "#D4D4D4",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                보너스쿠폰
                                            </Box>
                                            <Box
                                                sx={{
                                                    fontSize: "13px",
                                                    color: "#D4D4D4",
                                                    marginLeft: "3px",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {/* x{remain_count} */}
                                                x72
                                            </Box>
                                        </Box>
                                        <Box
                                            sx={{
                                                fontSize: "13px",
                                                color: "#D4D4D4",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {/* {enroll_sdate} ~ {enroll_edate} */}
                                            2022.06.20 까지
                                        </Box>
                                    </Box>
                                </Box>
                                <Radio
                                    size='small'
                                />
                            </Box>
                        }
                        label=''
                    />
                </RadioGroup>
            </FormControl>
        </Box>
    )
}

export default CouponSelect;